import { ResponseDTO } from './response-dto';
import { UserContextRoleProfileStatusDTO } from './user-context-role-profile-status-dto';

export interface ReadUserContextRoleProfileResponseDTO extends ResponseDTO {
    profile?: UserContextRoleProfileStatusDTO;
}
